/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2018 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/

import { publicApiNames } from "publicApis/constants";
import { apiFactory } from "api/external/ApiFactory";
import { getDocumentActionApis } from "publicApis/DocumentAction";
import { getDocumentInfoApis } from "publicApis/DocumentInfo";
import { getDocumentStateApis } from "publicApis/DocumentState";
import { getDocumentOverlaysApis } from "publicApis/DocumentOverlays";
import { getPageApis } from "publicApis/PageApis";
import { getReadAloudApis } from "publicApis/ReadAloudApis";
import { getCropApis } from "publicApis/CropApis";
import { getCaretModeApis } from "publicApis/CaretModeApis";
import { getHyperlinkApis } from "publicApis/HyperlinkApis";
import { getNumberPageApis } from "publicApis/NumberPageApis";
import { getEditApis } from "publicApis/EditApis";

const getDocumentApis = stores => {
  const documentActionApis = getDocumentActionApis(stores);
  const documentInfoApis = getDocumentInfoApis(stores);
  const documentStateApis = getDocumentStateApis(stores);
  const documentOverlaysApis = getDocumentOverlaysApis(stores);
  const pageApis = getPageApis(stores);
  const readAloudApis = getReadAloudApis(stores);
  const cropApis = getCropApis(stores);
  const caretModeApis = getCaretModeApis(stores);
  const hyperlinkApis = getHyperlinkApis(stores);
  const numberPageApis = getNumberPageApis(stores);
  const editApis = getEditApis(stores);

  return Object.assign(
    {},
    documentActionApis,
    documentInfoApis,
    documentStateApis,
    documentOverlaysApis,
    pageApis,
    readAloudApis,
    cropApis,
    caretModeApis,
    hyperlinkApis,
    numberPageApis,
    editApis
  );
};

export const registerDocumentApis = stores => {
  apiFactory.registerApi(publicApiNames.DOCUMENT, clientName => getDocumentApis(stores), true);
};
